import React, { useEffect } from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom";
import Img from "../../../../Assets/images/flawless-img/book-img.jpg";
import { Je_welryspelling } from "../../../../Helpers/request";

const ConsultSpecialist = () => {
  const history= useHistory();
  return (
    <section className="consult-specialist-section section-space pt-0">
      <Container fluid className="showcase-container">
        <div>
          <Row>
          <Col md={6} className="p-0">
              <Image src={Img} alt="Feel Free To Talk With Us" />
            </Col>
            <Col md={6}>
              <div className="inner-wrap text-center">
                {/* <span>Feel Free To Talk With Us</span> */}
                <h2>Visit our showroom </h2>
                <p>
                Step into our showroom and experience the elegance and craftsmanship
of our exclusive jewellery collections. From timeless classics to modern designs,
our carefully curated pieces are crafted to inspire. Whether you’re searching
for the perfect gift or a statement piece for yourself, our friendly experts are
here to guide you through a personalized shopping experience. Visit us today
to explore the brilliance that awaits!
                </p>
                <button
                  className="f__btn_green width-auto m-auto"
                  onClick={()=>history.push("/book-an-appointment")}
                >
                  Book an Appointment
                </button>
              </div>
            </Col>
            
          </Row>
        </div>
      </Container>
    </section>
  );
};

export default ConsultSpecialist;
